import { render, staticRenderFns } from "./BundleDiscountPillBadge.vue?vue&type=template&id=28ec3b79&scoped=true&"
import script from "./BundleDiscountPillBadge.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountPillBadge.vue?vue&type=script&lang=ts&"
import style0 from "./BundleDiscountPillBadge.vue?vue&type=style&index=0&id=28ec3b79&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec3b79",
  null
  
)

export default component.exports